// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs__tabs___KOXfP","tab":"Tabs__tab___3KK7U","is-active":"Tabs__is-active___2Vi_F","is-disabled":"Tabs__is-disabled___27ffU"};